import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  Answers: {},
};

export const AnswersSlice = createSlice({
  name: "AnswersSlice",
  initialState,
  reducers: {
    SetAnswers: (state, action) => {
      state.Answers = action.payload;
    },
    SetAnswersValue: (state, action) => {
      state.Answers.answers[action.payload.index].answer_value =
        action.payload.value;
    },
  },
});

// Action creators are generated for each case reducer function
export const { SetAnswers, SetAnswersValue } = AnswersSlice.actions;

export default AnswersSlice.reducer;
